export default "/assets/images/update-hero-img.29bc8f222efc89ad.webp";